const cleanDataV2 = (values) => {
  let filterArray = ["_", "__typename"];
  let data = values;
  filterArray.map((x) => {
    delete data[x];
    return data;
  });
  if (!values["files"]) {
    values["files"] = [];
  }
  // console.log("DATA HERE----------------------------", data, values);
  /*
   * This first if conditional is if a user decides to switch formVersionIds - specifically 2 to 1 -
   * and to remove the A1a choice that they made.
   */
  if (!values["a1_employer_type_a"]) {
    delete data["a1a_sole_employer"];
    delete data["a1a_joint_employer"];
    delete data["a1a_agent"];
  }

  if (
    values["a1_employer_type_a"] &&
    values["a1_employer_type_a"] === "association-sole"
  ) {
    data["a1a_sole_employer"] = "YES";
    delete data["a1a_joint_employer"];
    delete data["a1a_agent"];
  }
  if (
    values["a1_employer_type_a"] &&
    values["a1_employer_type_a"] === "association-joint"
  ) {
    data["a1a_joint_employer"] = "YES";
    delete data["a1a_sole_employer"];
    delete data["a1a_agent"];
  }
  if (
    values["a1_employer_type_a"] &&
    values["a1_employer_type_a"] === "association-agent"
  ) {
    data["a1a_agent"] = "YES";
    delete data["a1a_sole_employer"];
    delete data["a1a_joint_employer"];
  }

  if (
    values["a4_is_temp_need_complete_file"] &&
    typeof values["a4_is_temp_need_complete_file"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["a4_is_temp_need_complete_file"]
    );
    values["a4_is_temp_need_complete_file"] = "YES";
  }
  if (
    values["d20_is_agent_agreement_complete"] &&
    typeof values["d20_is_agent_agreement_complete"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["d20_is_agent_agreement_complete"]
    );
    values["d20_is_agent_agreement_complete"] = "YES";
  }
  if (
    values["a6_is_emergency_justification_complete"] &&
    typeof values["a6_is_emergency_justification_complete"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["a6_is_emergency_justification_complete"]
    );
    values["a6_is_emergency_justification_complete"] = "YES";
  }
  if (
    values["d21_is_agent_mspa_complete_file"] &&
    typeof values["d21_is_agent_mspa_complete_file"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["d21_is_agent_mspa_complete_file"]
    );
    values["d21_is_agent_mspa_complete_file"] = "YES";
  }
  if (
    values["e7_is_mspa_complete_file"] &&
    typeof values["e7_is_mspa_complete_file"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["e7_is_mspa_complete_file"]
    );
    values["e7_is_mspa_complete_file"] = "YES";
  }
  if (
    values["e8_is_surety_bond_complete"] &&
    typeof values["e8_is_surety_bond_complete"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["e8_is_surety_bond_complete"]
    );
    values["e8_is_surety_bond_complete"] = "YES";
  }
  if (
    values["f2_is_joint_appendix_a_complete"] &&
    typeof values["f2_is_joint_appendix_a_complete"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["f2_is_joint_appendix_a_complete"]
    );
    values["f2_is_joint_appendix_a_complete"] = "YES";
  }
  if (
    values["f1_is_appendix_a_complete"] &&
    typeof values["f1_is_appendix_a_complete"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["f1_is_appendix_a_complete"]
    );
    values["f1_is_appendix_a_complete"] = "YES";
  }
  if (
    data["e6_is_work_contracts_complete"] &&
    typeof data["e6_is_work_contracts_complete"] === "object"
  ) {
    data["e6_is_work_contracts_complete"].map((x) => {
      data["files"].push(x);
    });

    data["e6_is_work_contracts_complete"] = "YES";
  }

  if (values["files"]) {
    values["files"].filter(
      (file) => file.machine_name === "e6_is_work_contracts_complete"
    ).length > 0
      ? (data["e6_is_work_contracts_complete"] = "YES")
      : (data["e6_is_work_contracts_complete"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "f1_is_appendix_a_complete"
    ).length > 0
      ? (data["f1_is_appendix_a_complete"] = "YES")
      : typeof values?.formVersionId === "number" && values?.formVersionId === 2
      ? (data["f1_is_appendix_a_complete"] = null)
      : (data["f1_is_appendix_a_complete"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "f2_is_joint_appendix_a_complete"
    ).length > 0
      ? (data["f2_is_joint_appendix_a_complete"] = "YES")
      : typeof values?.formVersionId === "number" && values?.formVersionId === 2
      ? (data["f2_is_joint_appendix_a_complete"] = "N/A")
      : (data["f2_is_joint_appendix_a_complete"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "e7_is_mspa_complete_file"
    ).length > 0
      ? (data["e7_is_mspa_complete_file"] = "YES")
      : (data["e7_is_mspa_complete_file"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "e8_is_surety_bond_complete"
    ).length > 0
      ? (data["e8_is_surety_bond_complete"] = "YES")
      : (data["e8_is_surety_bond_complete"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "d21_is_agent_mspa_complete_file"
    ).length > 0
      ? (data["d21_is_agent_mspa_complete_file"] = "YES")
      : typeof values?.formVersionId === "number" && values?.formVersionId === 2
      ? (data["d21_is_agent_mspa_complete_file"] = "N/A")
      : (data["d21_is_agent_mspa_complete_file"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "d20_is_agent_agreement_complete"
    ).length > 0
      ? (data["d20_is_agent_agreement_complete"] = "YES")
      : typeof values?.formVersionId === "number" && values?.formVersionId === 2
      ? (data["d20_is_agent_agreement_complete"] = null)
      : (data["d20_is_agent_agreement_complete"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "a6_is_emergency_justification_complete"
    ).length > 0
      ? (data["a6_is_emergency_justification_complete"] = "YES")
      : typeof values?.formVersionId === "number" && values?.formVersionId === 2
      ? (data["a6_is_emergency_justification_complete"] = "N/A")
      : (data["a6_is_emergency_justification_complete"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "a4_is_temp_need_complete_file"
    ).length > 0
      ? (data["a4_is_temp_need_complete_file"] = "YES")
      : (data["a4_is_temp_need_complete_file"] = "NO");
    if (values["files"].length > 0) {
      for (let j = 0; j < values["files"].length; j++) {
        data["files"][j].size = data["files"][j].size.toString();

        delete data["files"][j].fileTypes;
        data["files"][j].lastModified =
          data["files"][j].lastModified.toString();

        delete data["files"][j].fileUploadedFrom;
        if (data["files"][j].__typename) {
          delete data["files"][j].__typename;
        }
      }
    }
  }
  return data;
};

const pageLockData = {
  lockedPage: 0,
  requiredFields: ["a5_is_emergency", "e3_is_job_order_complete"],
};

export { cleanDataV2, pageLockData };
